import coreApiService from './core.service';

export const mediaApi = {
    getAttachment: (key: string) => coreApiService.getBlob(`media/attachments/${key}`),
};
